var map = {
	"./auth/auth.module": [
		"./src/app/auth/auth.module.ts",
		"default~auth-auth-module~profile-profile-module",
		"common",
		"auth-auth-module"
	],
	"./bank-accounts/bank-accounts.module": [
		"./src/app/bank-accounts/bank-accounts.module.ts",
		"common",
		"bank-accounts-bank-accounts-module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"common",
		"dashboard-dashboard-module"
	],
	"./products/products.module": [
		"./src/app/products/products.module.ts",
		"common",
		"products-products-module"
	],
	"./profile/profile.module": [
		"./src/app/profile/profile.module.ts",
		"default~auth-auth-module~profile-profile-module",
		"common",
		"profile-profile-module"
	],
	"./support/support.module": [
		"./src/app/support/support.module.ts",
		"common",
		"support-support-module"
	],
	"./transactions/transactions.module": [
		"./src/app/transactions/transactions.module.ts",
		"common",
		"transactions-transactions-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;